import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Landing } from './pages/Landing';
import { Plans } from './pages/Plans';
import { Nodes } from './pages/Nodes';
import { Profile } from './pages/Profile';
import { Knowledge } from './pages/Knowledge';
import { Ticket } from './pages/Ticket';
import { Invite } from './pages/Invite';
import OrderDetailPage from './pages/OrderDetail';
import OrderStatus from './pages/OrderStatus';
import Orders from './pages/Orders';
import { PricingPage } from './pages/public/PricingPage';
import { FeaturesPage } from './pages/public/FeaturesPage';
import { DownloadPage } from './pages/public/DownloadPage';
import { DownloadPlatformPage } from './pages/public/DownloadPlatformPage';
import { HelpPage } from './pages/public/HelpPage';
import { AboutPage } from './pages/public/AboutPage';
import { PrivacyPage, TermsPage } from './pages/public/LegalPage';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import CrispChat from './components/CrispChat';
import { getConfig } from './utils/config';

import { AuthProvider } from './contexts/AuthContext';
import { TelegramProvider } from './contexts/TelegramContext';
import { ThemeProvider } from './contexts/ThemeContext';
import TelegramAutoLogin from './components/TelegramAutoLogin';
import './App.css';
import './styles/mobile.css';

function App() {
  return (
    <ThemeProvider>
      <TelegramProvider>
        <AuthProvider>
          <Router>
            <TelegramAutoLogin>
              <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
                <Routes>
                  {/* Chinese public pages */}
                  <Route path="/" element={<Landing />} />
                  <Route path="/landing" element={<Landing />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/features" element={<FeaturesPage />} />
                  <Route path="/download" element={<DownloadPage />} />
                  <Route path="/download/:platform" element={<DownloadPlatformPage />} />
                  <Route path="/help" element={<HelpPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />

                  {/* English public pages */}
                  <Route path="/en" element={<Landing />} />
                  <Route path="/en/pricing" element={<PricingPage />} />
                  <Route path="/en/features" element={<FeaturesPage />} />
                  <Route path="/en/download" element={<DownloadPage />} />
                  <Route path="/en/download/:platform" element={<DownloadPlatformPage />} />
                  <Route path="/en/help" element={<HelpPage />} />
                  <Route path="/en/about" element={<AboutPage />} />
                  <Route path="/en/privacy" element={<PrivacyPage />} />
                  <Route path="/en/terms" element={<TermsPage />} />
                  <Route path="/en/login" element={<Login />} />
                  <Route path="/en/register" element={<Register />} />

                  {/* Authenticated pages */}
                  <Route path="/dashboard" element={
                    <Layout>
                      <Dashboard />
                    </Layout>
                  } />
                  <Route path="/plans" element={
                    <Layout>
                      <Plans />
                    </Layout>
                  } />
                  <Route path="/order/:planId/:period" element={
                    <Layout>
                      <OrderDetailPage />
                    </Layout>
                  } />
                  <Route path="/order/status/:tradeNo" element={
                    <Layout>
                      <OrderStatus />
                    </Layout>
                  } />
                  <Route path="/orders" element={
                    <Layout>
                      <Orders />
                    </Layout>
                  } />
                  <Route path="/nodes" element={
                    <Layout>
                      <Nodes />
                    </Layout>
                  } />
                  <Route path="/knowledge" element={
                    <Layout>
                      <Knowledge />
                    </Layout>
                  } />
                  <Route path="/ticket" element={
                    <Layout>
                      <Ticket />
                    </Layout>
                  } />
                  <Route path="/invite" element={
                    <Layout>
                      <Invite />
                    </Layout>
                  } />
                  <Route path="/profile" element={
                    <Layout>
                      <Profile />
                    </Layout>
                  } />
                </Routes>
                <PWAInstallPrompt />
                <CrispChat websiteId={getConfig().crispWebsiteId} />
              </div>
            </TelegramAutoLogin>
          </Router>
        </AuthProvider>
      </TelegramProvider>
    </ThemeProvider>
  );
}

export default App;
